import debounce from "lodash/debounce";

const VALID_CEP_REGEX = /^[0-9]{8}$/;

const sanitizeCep = (value = "") =>
  String(value).replace(/\D/g, "").substring(0, 8);

const fetchCep = async (cep) => {
  const response = await fetch(`https://viacep.com.br/ws/${cep}/json/`);
  const payload = await response.json();

  if (payload?.erro) return null;

  return payload;
};

export const createCepFetcher = ({
  debounceMs = 0,
  onLoadingChange,
  onSuccess,
  onError,
} = {}) => {
  const run = async (value = "") => {
    const cep = sanitizeCep(value);

    if (!VALID_CEP_REGEX.test(cep)) {
      onLoadingChange?.(false);
      return null;
    }

    onLoadingChange?.(true);

    try {
      const payload = await fetchCep(cep);
      onSuccess?.(payload, cep);
      return payload;
    } catch (error) {
      onError?.(error);
      return null;
    } finally {
      onLoadingChange?.(false);
    }
  };

  if (debounceMs > 0) {
    return debounce(run, debounceMs);
  }

  return run;
};
